import snackbar from "components/snackbar";

export default {
  'TrainingVideoTableRow.Wrapper': ({ training  }, outlet) => {
    outlet({ action: 'row_clicked', training  });
  },
  "TrainingVideoTableRow.Wrapper.ThumbnailWrapper.CopyButton": (
    { link, isProcessing, isError, isLoading, },
    _outlet,
    internalStateSetter
  ) => {
    if(isProcessing || isError || isLoading) {
      return
    }
    const text = new ClipboardItem({
      "text/plain": new Blob([link], { type: "text/plain" }),
    });

    navigator.clipboard
      .write([text])
      .then(() => {
        internalStateSetter({
          linkCopied: true,
        });

        setTimeout(() => {
          internalStateSetter({
            linkCopied: false,
          });
        }, 3000);
      })
      .catch(() => {
        snackbar({
          message: "Failed to copy",
          args: { type: "error" },
        });
      });
  },
};
